import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./plugins/axios";
import { debounce } from "lodash";
import { VueMasonryPlugin } from "vue-masonry";
import MasonryWall from "@yeger/vue-masonry-wall";
import { setRootSize } from "./utils";
import "@/assets/style/base.scss";
import vue3VideoPlay from "vue3-video-play";
const app = createApp(App);
let timer = null;
setRootSize();
window.addEventListener("resize", debounce(setRootSize, 30));
setToastDefaultOptions("loading", {
  forbidClick: true
});
app.use(store).use(router).use(axios).use(vue3VideoPlay);
app.use(VueMasonryPlugin);
app.use(MasonryWall);
app.mount("#app");